<template>
    <wj-popup
        style="width: 20%"
        class="wj-popup"
        role="dialog"
        :initialized="initCountRowsPopup"
        >
        <div class="modal-header wj-dialog-header header-countRowsPopup">
            <h5>
            {{ this.$t("common.nbrRecords") }}
            </h5>
        </div>
        <div class="modal-body wj-dialog-body body-countRowsPopup">
            <p>
            {{ this.totalCount }}
            {{ this.$t("common.showCountRecords") }}
            </p>
        </div>
        <div class="modal-footer wj-dialog-footer footer-countRowsPopup">
            <button
            class="btn btn-primary wj-btn, wj-hide-ok button-countRowsPopup"
            >
            OK
            </button>
        </div>
    </wj-popup>
</template>
<script>
import { WjPopup } from "@grapecity/wijmo.vue2.input";

export default {
    name: 'Popup',
    inject: ["lang"],
    components: {
    'wj-popup':WjPopup
    },
    props: {
        totalCount: {
            type: Number,
            required: true,
        },
    },
    methods: {
        initCountRowsPopup(popup) {
            this.$emit('init-popup', popup);
        }
    },
};
</script>

<style scoped>
.header-countRowsPopup {
  font-family: "D-DIN-700" !important;
  background: #bbdbfd !important;
  color: #030f40 !important;
  font-size: 12px !important;
  font-style: normal;
  align-items: center;
  padding: 12px 10px !important;
}

.body-countRowsPopup {
  font-family: "D-DIN" !important;
  color: #030f40 !important;
  font-size: 0.9rem !important;
  font-style: normal;
  align-items: center;
}

.footer-countRowsPopup {
  padding: 0.2rem !important;
}

.button-countRowsPopup {
  background: #eeeeee !important;
  color: #030f40 !important;
  width: 75px;
  height: 25px;
  padding: 1px !important;
  font-family: "D-DIN-700" !important;
  font-size: 12px !important;
  font-style: normal;
  align-items: center;
  border-radius: 5px;
  box-sizing: border-box;
  border: 0.5px solid #d0d8e6;
}

.button-countRowsPopup:focus {
  outline: none !important;
  box-shadow: none !important;
}

.button-countRowsPopup:focus,
.button-countRowsPopup:active {
  outline: none !important;
  box-shadow: none !important;
  border: 1px solid #d0d8e6 !important;
}

.button-countRowsPopup:hover {
  background-color: #deebf8 !important;
  text-decoration: none;
}
</style>